var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00002 8.99978L12.17 8.99978L7.29002 13.8798C6.90002 14.2698 6.90002 14.9098 7.29002 15.2998C7.68002 15.6898 8.31002 15.6898 8.70002 15.2998L15.29 8.70978C15.68 8.31979 15.68 7.68979 15.29 7.29979L8.70002 0.709784C8.31002 0.319784 7.68002 0.319783 7.29002 0.709784C6.90002 1.09978 6.90002 1.72979 7.29002 2.11979L12.17 6.99979L1.00002 6.99978C0.450021 6.99978 2.0739e-05 7.44978 2.06909e-05 7.99978C2.06428e-05 8.54978 0.45002 8.99978 1.00002 8.99978Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forwardArrow.474711d50acab696b82fa1d84c12ed10.svg";
export { ForwardRef as ReactComponent };